<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        /> 

        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="tableData"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    :loading="isLoading"
                >
                    <template v-slot:bottom-row>
                        <q-tr
                            v-if="
                                tableData.length == 0 && !isLoading && !isError
                            "
                        >
                            <q-td colspan="8">No records available</q-td>
                        </q-tr>
                    </template>

                    <template v-slot:header-cell="props">
                        <q-th :props="props">
                            <strong class="text-capitalize">{{
                                props.col.label
                            }}</strong>
                        </q-th>
                    </template>
                    <template v-slot:body-cell-Client="props">
                        <q-td :props="props" class="">
                            <client-name
                                openNew
                                :use-router="USE_CLIENT_MODULE_VUE"
                                :client="generateClientObject(props.row)"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Patient="props">
                        <q-td :props="props">
                            <patient-name
                                openNew
                                v-if="props.row.patient"
                                :use-router="USE_PATIENT_MODULE_VUE"
                                :patient="generatePatientObject(props.row)"
                                :show-status="true"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-ItemAmount="props">
                        <q-td :props="props">
                            <span v-if="props.row.item_amount !== null">{{
                                _toCurrency(props.row.item_amount)
                            }}</span>
                        </q-td>
                    </template>
                    <template v-slot:body-cell-DiscountAmount="props">
                        <q-td :props="props">
                            <span v-if="props.row.discount_amount !== null">{{
                                _toCurrency(props.row.discount_amount)
                            }}</span>
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Item="props">
                        <q-td :props="props">
                            <item-name
                                :item="{
                                    name: props.row.item_name,
                                    encodedId: props.row.item_id
                                }"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Invoice="{ row }">
                        <td class="text-nowrap">
                            <invoice-link
                                :href="env.APPS"
                                :invoice="{
                                    encoded_id: row.invoice_id
                                }"
                                :text="row.invoice_no"
                            />
                        </td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import { QTable } from "quasar";
import Report from "@/mixins/report";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import PatientName from "@/components/commons/patient-name";
import InvoiceLink from "@/components/commons/invoice-link";
import ClientName from "@/components/commons/client-name";
import ItemName from "@/components/commons/item-name";
import "@/css/quasar-table.css";
export default {
    mixins: [Report],
    components: {
        QTable,
        PatientName,
        InvoiceLink,
        ClientName,
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("week"),
                    end: this.getEndDate("day"),
                    from: this.converToUnix(this.start),
                    to: this.converToUnix(this.end)
                };
            }
        }
    },
    data() {
        return {
            headerTotal: "Total",
            isLoading: true,
            isError: false,
            tableData: [],
            dateRange: "",
            title: "Discount Details",
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            USE_PATIENT_MODULE_VUE:
                process.env.USE_PATIENT_MODULE_VUE === "true"
        };
    },
    computed: {
        formattedColumns() {
            return [
                {
                    name: "Invoice",
                    label: "Invoice No",
                    field: "invoice_no",
                    align: "left",
                    style: "white-space: nowrap;"
                },
                {
                    name: "Client",
                    label: "Client Name",
                    field: "Client",
                    align: "left",
                    style: "width:16%",
                    classes: "text-capitalize"
                },
                {
                    name: "Patient",
                    label: "Patient",
                    field: "Patient",
                    align: "left",
                    style: "width:10%",
                    classes: "text-capitalize"
                },
                {
                    name: "Item",
                    label: "Item Name",
                    field: "item_name",
                    align: "left",
                    style: "width:16%",
                    classes: "text-capitalize"
                },
                {
                    name: "ItemType",
                    label: "Item Type",
                    field: "item_type",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "ItemCategory",
                    label: "Item Category",
                    field: "item_category",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "BillingDate",
                    label: "Billing Date",
                    field: "billing_date",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "ItemAmount",
                    label: "Item Amount",
                    field: "item_amount",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "DiscountAmount",
                    label: "Discount Amount",
                    field: "discount_amount",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "DiscountPercent",
                    label: "Discount Percent",
                    field: "discount_percent",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "DiscountName",
                    label: "Discount Name",
                    field: "discount_name",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "Provider",
                    label: "Provider",
                    field: "provider",
                    align: "left",
                    classes: "text-capitalize"
                },
                {
                    name: "DiscountBy",
                    label: "Discount By",
                    field: "discounted_by",
                    align: "left",
                    classes: "text-capitalize"
                }
            ];
        }
    },
    async mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = true;
        self.data.isShowProvider = false;
        self.data.isShowDateRange = true;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("week");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.fetchData();
        });

        self.$root.$on("report-filter-date-range:refresh", self.init);
        self.$root.$on("discount-details:refresh", function () {
            self.fetchData(1);
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        init(params) {
            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.start = params.start;
                this.data.end = params.end;
            }
            this.fetchData();
        },
        generatePatientObject(row) {
            return {
                name: row.patient,
                encodedId: row.patient_id,
                isactive: !row.patient.includes("(deleted)")
            };
        },
        generateClientObject(row) {
            return {
                id: row.client_id,
                name: row.client_name.replace("(deleted)", ""),
                encoded_id: !row.client_name.includes("(deleted)")
                    ? row.client_id
                    : null,
                isactive: !row.client_name.includes("(deleted)")
            };
        },
        async fetchData(refresh) {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            let params = {
                from: self.data.from,
                to: self.data.to
            };
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            if (refresh) {
                params.refresh = refresh;
            }

            await ReportService.getReport(CREPORT.TYPE.DISCOUNT_DETAILS, params)
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.tableData = res.resource.results;
                        self.dateRange = self.getDateRange(
                            res.resource.meta.fromDate,
                            res.resource.meta.toDate
                        );
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e.message);
                    self.isError = true;
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        }
    }
};
</script>
